<template>
  <svg width="17.286" height="22" viewBox="0 0 17.286 22">
    <path d="M17.055,5.515,11.771.231A.784.784,0,0,0,11.216,0H.786A.785.785,0,0,0,0,.786V21.214A.785.785,0,0,0,.786,22H16.5a.785.785,0,0,0,.786-.786V6.072A.79.79,0,0,0,17.055,5.515Zm-1.581.918H10.853V1.812Zm.044,13.8H1.768V1.768H9.183v5.3A1.031,1.031,0,0,0,10.214,8.1h5.3Zm-6.823-7.56L7.177,10.158a.3.3,0,0,0-.253-.142H5.981a.274.274,0,0,0-.157.047.294.294,0,0,0-.091.408l2.021,3.2L5.706,16.932a.3.3,0,0,0,.25.452H6.8a.3.3,0,0,0,.25-.14l1.54-2.492,1.53,2.49a.293.293,0,0,0,.25.14h.921a.309.309,0,0,0,.16-.047.294.294,0,0,0,.088-.408l-2.062-3.2,2.094-3.253a.3.3,0,0,0-.248-.454H10.45a.3.3,0,0,0-.253.142l-1.5,2.512Z" transform="translate(0)" fill="#2850a0"/>
  </svg>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "fileexelicon"
})
</script>